module.exports = __webpack_public_path__ + "img/search.fee1f99c.svg";